import {ready} from "../utils/ready.mjs";

;(function () {
    'use strict';

    // init main navigation
    ready(function () {

        let connection = false;
        let slowConnection = false;
        const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

        if ("connection" in navigator || "mozConnection" in navigator || "webkitConnection" in navigator) {
            connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            // update connection speed flag
            slowConnection = (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g' || connection.effectiveType === '3g');
        }

        if (connection && connection.saveData === true) {
            // data saver is on, don't fader
        } else if (slowConnection) {
            // slow connection, don't load fader
        } else if (reducedMotionQuery && reducedMotionQuery.matches) {
            // reduced motion: don't load fader
        } else {

            let current = 0;
            let slides = document.querySelectorAll('.Hero__image');

            // wait 2 seconds to do anything to delay loading of the hidden images
            setTimeout(function () {

                if (slides.length > 1) {
                    // load hidden images
                    for (let i = 0; i < slides.length; i++) {
                        slides[i].style.display = 'block';
                    }
                    // start slider
                    setInterval(function() {
                        if (!slides[0].parentElement.classList.contains('paused')) {
                            for (let i = 0; i < slides.length; i++) {
                                slides[i].style.opacity = 0;
                            }
                            current = (current !== slides.length - 1) ? current + 1 : 0;
                            slides[current].style.opacity = 1;
                        }
                    }, 4000);
                }

            }, 2000);

            let button = document.querySelector('.Hero__image-button');
            if (typeof(button) != 'undefined' && button != null) {

                if (slides.length > 1) {
                    button.style.display = 'flex';

                    button.addEventListener('click', function (e) {
                        e.preventDefault();
                        button.parentElement.classList.toggle('paused');
                    });
                }
            }

        }
    });
}());
